import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/christophkranebitter/renehuemer.com/website/node_modules/next/dist/client/app-dir/link.js");
